import {
  ACCOMPANYING_REPORT_FORM_INITIAL_DATA as ACCOMPANYING_REPORT_FORM_INITIAL_DATA_SHARED,
  UsageMethodEnum,
} from 'shared'
import { ISelectOption } from '../../../../model/interfaces/ISelectOption'
import {FileTreeElement} from "../../../../components/inputs/FileTreeInput";

export const ACCOMPANYING_REPORT_FORM_INITIAL_DATA = {
  ...ACCOMPANYING_REPORT_FORM_INITIAL_DATA_SHARED,
}

export const ACCOMPANYING_REPORT_A3_CONSTRUCTION_TYPE: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 Zděný z nepálených cihel',
    label: '2 Zděný z nepálených cihel',
  },
  {
    value: '3 Zděný cihelný',
    label: '3 Zděný cihelný',
  },
  {
    value: '4 Zděný kamenný',
    label: '4 Zděný kamenný',
  },
  {
    value: '5 Zděný jiné',
    label: '5 Zděný jiné',
  },
  {
    value: '6 Zděný smíšený',
    label: '6 Zděný smíšený',
  },
  {
    value: '7 Monolitický betonový',
    label: '7 Monolitický betonový',
  },
  {
    value: '8 Montované stěnové panely betonové',
    label: '8 Montované stěnové panely betonové',
  },
  {
    value: '9 Montované stěnové panely dřevěné',
    label: '9 Montované stěnové panely dřevěné',
  },
  {
    value: '10 Montované stěnové panely jiné',
    label: '10 Montované stěnové panely jiné',
  },
  {
    value: '11 Dřevo – sruby a roubenky',
    label: '11 Dřevo – sruby a roubenky',
  },
  {
    value: '12 Dřevo – lehký rámcový skelet – panelová montáž',
    label: '12 Dřevo – lehký rámcový skelet – panelová montáž',
  },
  {
    value: '13 Dřevo – lehký rámcový skelet – staveništní montáž',
    label: '13 Dřevo – lehký rámcový skelet – staveništní montáž',
  },
  {
    value: '14 Dřevo – těžký skelet',
    label: '14 Dřevo – těžký skelet',
  },
  {
    value: '15 Panely z masivního dřeva',
    label: '15 Panely z masivního dřeva',
  },
  {
    value: '16 Dřevo – ostatní dřevěné konstrukce',
    label: '16 Dřevo – ostatní dřevěné konstrukce',
  },
  {
    value: '17 Kombinovaný',
    label: '17 Kombinovaný',
  },
  {
    value: '18 Speciální a jiné',
    label: '18 Speciální a jiné',
  },
]

export const ACCOMPANYING_REPORT_A3_HEATHING_METHOD_OPTIONS: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 Ústřední dálkové',
    label: '2 Ústřední dálkové',
  },
  {
    value: '3 Ústřední domovní',
    label: '3 Ústřední domovní',
  },
  {
    value: '4 Ústřední bytové',
    label: '4 Ústřední bytové',
  },
  {
    value: '5 Kombinované',
    label: '5 Kombinované',
  },
  {
    value: '6 Lokální zdroje',
    label: '6 Lokální zdroje',
  },
  {
    value: '7 Bez vytápění',
    label: '7 Bez vytápění',
  },
]

export const ACCOMPANYING_REPORT_A3_WATER_CONNECTION_OPTIONS: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 bez zdroje',
    label: '2 bez zdroje',
  },
  {
    value: '3 Centrální zdroj',
    label: '3 Centrální zdroj',
  },
  {
    value: '4 Lokální zdroj',
    label: '4 Lokální zdroj',
  },
  {
    value: '5 Lokální zásobník',
    label: '5 Lokální zásobník',
  },
  {
    value: '6 Kombinované',
    label: '6 Kombinované',
  },
]

export const ACCOMPANYING_REPORT_A3_SEWER_CONNECTION_OPTIONS: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 Bez zajištění',
    label: '2 Bez zajištění',
  },
  {
    value: '3 Jednotná kanalizace s centrální čistírnou odpadních vod',
    label: '3 Jednotná kanalizace s centrální čistírnou odpadních vod',
  },
  {
    value: '4 Jednotná kanalizace bez centrální čistírny odpadních vod',
    label: '4 Jednotná kanalizace bez centrální čistírny odpadních vod',
  },
  {
    value: '5 Oddílná kanalizace s centrální čistírnou odpadních vod',
    label: '5 Oddílná kanalizace s centrální čistírnou odpadních vod',
  },
  {
    value: '6 Lokální čistírna odpadních vod',
    label: '6 Lokální čistírna odpadních vod',
  },
  {
    value: '7 Lokální zásobník',
    label: '7 Lokální zásobník',
  },
  {
    value: '8 Kombinované',
    label: '8 Kombinované',
  },
]

export const ACCOMPANYING_REPORT_A3_GAS_CONNECTION_OPTIONS: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 Bez zdroje',
    label: '2 Bez zdroje',
  },
  {
    value: '3 Veřejná síť',
    label: '3 Veřejná síť',
  },
  {
    value: '4 Domovní zásobník – bez rozlišení',
    label: '4 Domovní zásobník – bez rozlišení',
  },
  {
    value: '5 Domovní zásobník – LPG',
    label: '5 Domovní zásobník – LPG',
  },
  {
    value: '6 Domovní zásobník – CNG',
    label: '6 Domovní zásobník – CNG',
  },
  {
    value: '7 Domovní zásobník – LNG',
    label: '7 Domovní zásobník – LNG',
  },
  {
    value: '8 Domovní zásobník – bioplyn',
    label: '8 Domovní zásobník – bioplyn',
  },
  {
    value: '9 Domovní zásobník – degazační',
    label: '9 Domovní zásobník – degazační',
  },
  {
    value: '10 Domovní zásobník – jiné',
    label: '10 Domovní zásobník – jiné',
  },
  {
    value: '11 Kombinované',
    label: '11 Kombinované',
  },
]

export const ACCOMPANYING_REPORT_A3_ELEVATOR_OPTIONS: ISelectOption[] = [
  {
    value: '1 Nezjištěno',
    label: '1 Nezjištěno',
  },
  {
    value: '2 S výtahem',
    label: '2 S výtahem',
  },
  {
    value: '3 S výtahem bezbariérovým',
    label: '3 S výtahem bezbariérovým',
  },
  {
    value: '4 Bez výtahu',
    label: '4 Bez výtahu',
  },
]

export const USAGE_METHOD_OPTIONS: FileTreeElement[] = [
  {
    id: '1',
    isSelectable: true,
    name: '1. Budovy',
    children: [
      {
        id: '1.1',
        isSelectable: true,
        name: '1.1 Budovy bytové',
        children: [
          {
            id: '1.1.1',
            isSelectable: true,
            name: '1.1.1 Budovy jednobytové',
            children: [
              {
                id: '1.1.1.0',
                isSelectable: true,
                name: '1.1.1.0 Budovy jednobytové',
                children: [
                  {
                    id: '1.1.1.0.1.1',
                    isSelectable: true,
                    name: UsageMethodEnum.SINGLE_RESIDENTIAL,
                  },
                  {
                    id: '1.1.1.0.1.2',
                    isSelectable: true,
                    name: UsageMethodEnum.SINGLE_RESIDENTIAL_WITH_SERVICE,
                  },
                  {
                    id: '1.1.1.0.2.1',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_HOUSE_SINGLE,
                  },
                  {
                    id: '1.1.1.0.2.2',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_COTTAGE_SINGLE,
                  },
                  {
                    id: '1.1.1.0.9.1',
                    isSelectable: true,
                    name: UsageMethodEnum.BUILDING_FENCE_SINGLE,
                  },
                ],
              },
            ],
          },
          {
            id: '1.1.2',
            isSelectable: true,
            name: '1.1.2 Budovy dvou a vícebytové',
            children: [
              {
                id: '1.1.2.1',
                isSelectable: true,
                name: '1.1.2.1 Budovy dvoubytové',
                children: [
                  {
                    id: '1.1.2.1.1.1',
                    isSelectable: true,
                    name: UsageMethodEnum.TWO_RESIDENTIAL,
                  },
                  {
                    id: '1.1.2.1.1.2',
                    isSelectable: true,
                    name: UsageMethodEnum.TWO_RESIDENTIAL_WITH_SERVICE,
                  },
                  {
                    id: '1.1.2.1.2.1',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_HOUSE_DOUBLE,
                  },
                  {
                    id: '1.1.2.1.2.2',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_COTTAGE_DOUBLE,
                  },
                  {
                    id: '1.1.2.1.9.1',
                    isSelectable: true,
                    name: UsageMethodEnum.BUILDING_FENCE_DOUBLE,
                  },
                ],
              },
              {
                id: '1.1.2.2',
                isSelectable: true,
                name: '1.1.2.2 Budovy tří a vícebytové',
                children: [
                  {
                    id: '1.1.2.2.1.3',
                    isSelectable: true,
                    name: UsageMethodEnum.THREE_RESIDENTIAL_TYPICAL,
                  },
                  {
                    id: '1.1.2.2.1.4',
                    isSelectable: true,
                    name: UsageMethodEnum.THREE_RESIDENTIAL_ATYPICAL,
                  },
                  {
                    id: '1.1.2.2.1.5',
                    isSelectable: true,
                    name: UsageMethodEnum.MULTI_RESIDENTIAL_TYPICAL,
                  },
                  {
                    id: '1.1.2.2.1.6',
                    isSelectable: true,
                    name: UsageMethodEnum.MULTI_RESIDENTIAL_ATYPICAL,
                  },
                  {
                    id: '1.1.2.2.2.1',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_HOUSES_MULTI,
                  },
                  {
                    id: '1.1.2.2.2.2',
                    isSelectable: true,
                    name: UsageMethodEnum.VACATION_COTTAGES_MULTI,
                  },
                  {
                    id: '1.1.2.2.9.1',
                    isSelectable: true,
                    name: UsageMethodEnum.BUILDING_FENCE_MULTI,
                  },
                ],
              },
            ],
          },
          {
            id: '1.1.3',
            isSelectable: true,
            name: '1.1.3 Budovy bytové ostatní',
            children: [
              {
                id: '1.1.3.1',
                isSelectable: true,
                name: '1.1.3.1 Budovy bytové ostatní',
                children: [
                  {
                    id: '1.1.3.0.1.1',
                    isSelectable: true,
                    name: UsageMethodEnum.OTHER_RESIDENTIAL_SOCIAL,
                  },
                  {
                    id: '1.1.3.0.1.2',
                    isSelectable: true,
                    name: UsageMethodEnum.OTHER_RESIDENTIAL_STUDENT,
                  },
                  {
                    id: '1.1.3.0.1.9',
                    isSelectable: true,
                    name: UsageMethodEnum.OTHER_RESIDENTIAL_OTHER,
                  },
                  {
                    id: '1.1.3.0.9.1',
                    isSelectable: true,
                    name: UsageMethodEnum.BUILDING_FENCE_OTHER,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]
